import {useState, useEffect} from 'react';
import axios from "../../utils/axios";

export default function useGetBanners(path) {
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  async function fetchData() {
    try {
      setLoading(true);
      const response = await axios.get(`/banners/banner_por_path_estado?path=${path}&estado=true`);
      setBanners(response.data.data);
      setLoading(false);
    } catch(err) {
      setLoading(false);
      setError(err);
      console.log(err);
    }
  }

  useEffect(() => {
    fetchData();
  }, [])
  return {banners, loading, error};
}
